import type { Config } from '@carbonara/config/src/config'
import ph from 'posthog-js'

import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'
import SuspendedPostHogPageView from './PostHogPageView'

interface Props {
	config: Config['posthog']
	children: React.ReactNode
}

export const PostHogProvider: React.FC<Props> = ({ config, children }) => {
	useEffect(() => {
		if (config.enabled) {
			ph.init(config.apiKey, {
				api_host: '/ingest',
				ui_host: config.uiHost,
				// https://posthog.com/docs/libraries/next-js#capturing-pageviews
				capture_pageview: false,
				capture_pageleave: true,
			})
		}
	})

	if (config.enabled) {
		return <PHProvider client={ph}>{children}</PHProvider>
	}

	return (
		<>
			<SuspendedPostHogPageView />
			{children}
		</>
	)
}
